import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';
import millify from 'utils/millify';
import Tooltip from '@material-ui/core/Tooltip';
import { stripDecimalsAndFormat } from 'utils/misc';

const styles = theme => ({
  wrapper: {
    display: 'flex',
    alignItems: 'center',
  },
  statWrapper: {
    display: 'flex',
    alignItems: 'center',
    color: theme.palette.secondary[900],
    fontSize: '0.875rem',
    fontWeight: 500,
  },
  value: {
    marginLeft: '0.5rem',
    fontSize: '1rem',
    fontWeight: 600,
    color: theme.palette.secondary.text,
  },
  divider: {
    margin: '0 1rem',
    width: '0.625rem',
    backgroundColor: theme.palette.grey.contrastText,
    transform: 'rotate(90deg)',
  },
});

const Summary = ({
  classes, hitsCount, totalReach, averageReach,
}) => (
  <div className={classes.wrapper}>
    <div className={classes.statWrapper}>
      <span className>HITS</span>
      <span className={classes.value}>{hitsCount}</span>
    </div>
    <hr className={classes.divider} />
    <div className={classes.statWrapper}>
      <span className>Average Reach</span>
      <span className={classes.value}>
        <Tooltip title={stripDecimalsAndFormat(averageReach)}>
          <span>{millify(averageReach)}</span>
        </Tooltip>
      </span>
    </div>
    <hr className={classes.divider} />
    <div className={classes.statWrapper}>
      <span className>Total Reach</span>
      <span className={classes.value}>
        <Tooltip title={stripDecimalsAndFormat(totalReach)}>
          <span>{millify(totalReach)}</span>
        </Tooltip>
      </span>
    </div>
  </div>
);

Summary.propTypes = {
  classes: PropTypes.element.isRequired,
  hitsCount: PropTypes.number.isRequired,
  totalReach: PropTypes.number.isRequired,
  averageReach: PropTypes.number.isRequired,
};

export default withStyles(styles)(Summary);
